import { useState } from "react";
// import {
//   registerAuth,
//   sendEmailVerificationCode,
//   verifyEmailCode,
// } from "../../services/authService";
import { useNavigate, Link } from "react-router-dom";
import { registerPartner } from "../../services/partnerService";
import "./Register.css";
import { Helmet } from "react-helmet";

const SECTORS = [
  "eSIM resellers",
  "eSIM affiliates",
  "Travel Industry",
  "MVNO",
  "MNO",
  "Fintech",
  "Enterprise",
  "Hospitality & Hotels",
  "Booking Platforms",
  "Airlines & Airports",
  "IoT & Embedded Devices",
];

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    password: "",
    username: "",
    company: "",
    address: "",
    sector: "",
    registration_number: "",
    agreeTerms: false,
    marketingOptIn: false,
  });
  const [showPwd, setShowPwd] = useState(false);
  const [status, setStatus] = useState(null); // {type: 'loading'|'error'|'info'|'success', msg: string}
  // const [code, setCode] = useState("");

  const onChange = (e) => {
    const { name, type, value, checked } = e.target;

    setForm((f) => ({
      ...f,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validate = () => {
    // if (form.password.length < 8) {
    //   return { ok: false, msg: "Password must be at least 8 characters." };
    // }
    if (
      !form.email.trim() ||
      !form.username.trim() ||
      !form.company.trim() ||
      !form.address.trim() ||
      !form.sector.trim() ||
      !form.registration_number.trim() ||
      !form.country.trim() ||
      !form.phone_number.trim()
    ) {
      return { ok: false, msg: "Please fill in all fields." };
    }
    if (!form.agreeTerms) {
      return {
        ok: false,
        msg: "You must agree to the Terms and Privacy Policy.",
      };
    }
    return { ok: true };
  };

  // const handleSendCode = async (e) => {
  //   e.preventDefault();
  //   const v = validate();
  //   if (!v.ok) {
  //     setStatus({ type: "error", msg: v.msg });
  //     return;
  //   }
  //   setStatus({ type: "loading", msg: "Sending verification code..." });
  //   try {
  //     await sendEmailVerificationCode(form.email.trim());
  //     setStatus({
  //       type: "info",
  //       msg: "Verification code sent to your email. Enter it to complete registration.",
  //     });
  //   } catch (err) {
  //     setStatus({
  //       type: "error",
  //       msg: err?.message || "Failed to send code. Try again.",
  //     });
  //   }
  // };

  // const handleVerifyAndRegister = async () => {
  //   if (!code.trim()) {
  //     setStatus({ type: "error", msg: "Enter the verification code." });
  //     return;
  //   }
  //   setStatus({ type: "loading", msg: "Verifying email..." });
  //   try {
  //     // 1) Weryfikacja kodu
  //     await verifyEmailCode({ email: form.email.trim(), code: code.trim() });

  //     // 2) Rejestracja auth
  //     setStatus({ type: "loading", msg: "Creating account..." });
  //     await registerAuth({
  //       email: form.email.trim(),
  //       password: form.password,
  //       username: form.username.trim(),
  //     });

  //     // 3) Rejestracja partnera
  //     await registerPartner({
  //       company: form.company.trim(),
  //       address: form.address.trim(),
  //       sector: form.sector,
  //       email: form.email.trim(),
  //       username: form.username.trim(),
  //       registration_number: form.registration_number.trim(),
  //     });

  //     // 4) Tylko komunikat sukcesu — brak logowania i brak redirectu
  //     setStatus({
  //       type: "success",
  //       msg: "Account created and email verified successfully.",
  //     });
  //   } catch (err) {
  //     setStatus({
  //       type: "error",
  //       msg: err?.message || "Verification or registration failed. Try again.",
  //     });
  //   }
  // };

  const handleRegister = async (e) => {
    e.preventDefault();
    const v = validate();
    if (!v.ok) {
      setStatus({ type: "error", msg: v.msg });
      return;
    }

    setStatus({ type: "loading", msg: "Creating partner account..." });
    try {
      await registerPartner({
        company: form.company.trim(),
        address: form.address.trim(),
        sector: form.sector,
        email: form.email.trim(),
        username: form.username.trim(),
        registration_number: form.registration_number.trim(),
        country: form.country.trim(),
        phone_number: form.phone_number.trim(),
        receive_special_deals: form.marketingOptIn,
      });

      setStatus({
        type: "success",
        msg: "Partner account created. Your account is being verified by our team.",
      });

      setTimeout(() => {
        navigate("/partner-offers");
      }, 3000);

      setTimeout(() => setStatus(null), 4000);
    } catch (err) {
      setStatus({
        type: "error",
        msg: err?.message || "Registration failed. Try again.",
      });
      setTimeout(() => setStatus(null), 4000);
    }
  };

  return (
    <main className="register">
      <Helmet>
        <title>GlobTel Esim - Register</title>
      </Helmet>

      <header className="register__hero">
        <h1>Create account</h1>
        <p className="register__lead">
          Partner portal access for managing plans, eSIMs, billing and more.
        </p>
      </header>

      <section className="register__wrap">
        <form
          className="register__form"
          onSubmit={handleRegister}
          noValidate
          aria-labelledby="registerTitle"
        >
          <h2 id="registerTitle" className="sr-only">
            Registration form
          </h2>

          <div className="grid">
            <div className="field">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                name="username"
                type="text"
                value={form.username}
                onChange={onChange}
                required
                aria-required="true"
                autoComplete="username"
                placeholder="user123"
              />
            </div>

            <div className="field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                value={form.email}
                onChange={onChange}
                required
                aria-required="true"
                autoComplete="email"
                placeholder="user@example.com"
              />
            </div>

            {/* <div className="field field--password">
              <label htmlFor="password">Password</label>
              <div className="pwd-wrap">
                <input
                  id="password"
                  name="password"
                  type={showPwd ? "text" : "password"}
                  value={form.password}
                  onChange={onChange}
                  required
                  aria-required="true"
                  autoComplete="new-password"
                  placeholder="SecurePass123!"
                />
                <button
                  type="button"
                  className="pwd-toggle"
                  onClick={() => setShowPwd((v) => !v)}
                  aria-label={showPwd ? "Hide password" : "Show password"}
                >
                  {showPwd ? "Hide" : "Show"}
                </button>
              </div>
            </div> */}

            <div className="field">
              <label htmlFor="company">Company name</label>
              <input
                id="company"
                name="company"
                type="text"
                value={form.company}
                onChange={onChange}
                required
                aria-required="true"
                placeholder="Your Company"
              />
            </div>

            <div className="field">
              <label htmlFor="phone_number">Phone number</label>
              <input
                id="phone_number"
                name="phone_number"
                type="tel"
                value={form.phone_number}
                onChange={onChange}
                required
                placeholder="+48 123 456 789"
              />
            </div>

            <div className="field">
              <label htmlFor="address">Address</label>
              <input
                id="address"
                name="address"
                type="text"
                value={form.address}
                onChange={onChange}
                required
                placeholder="Street, City"
              />
            </div>

            <div className="field">
              <label htmlFor="country">Country</label>
              <input
                id="country"
                name="country"
                type="text"
                value={form.country}
                onChange={onChange}
                required
                placeholder="Country"
              />
            </div>

            <div className="field">
              <label htmlFor="registration_number">Registration number</label>
              <input
                id="registration_number"
                name="registration_number"
                type="text"
                value={form.registration_number}
                onChange={onChange}
                required
                aria-required="true"
                placeholder="Company register number"
              />
            </div>

            <div className="field">
              <label htmlFor="sector">Sector</label>
              <select
                id="sector"
                name="sector"
                value={form.sector}
                onChange={onChange}
                required
                aria-required="true"
              >
                <option value="" disabled>
                  Select sector
                </option>
                {SECTORS.map((s) => (
                  <option value={s} key={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="checkboxes">
            <label className="checkbox">
              <input
                type="checkbox"
                name="agreeTerms"
                checked={form.agreeTerms}
                onChange={onChange}
                required
              />
              <span>
                I have read and agree to the{" "}
                <Link to="/terms" className="link-primary">
                  Terms and Conditions
                </Link>{" "}
                and{" "}
                <Link to="/privacy-policy" className="link-primary">
                  Privacy Policy
                </Link>
                .
              </span>
            </label>

            <label className="checkbox">
              <input
                type="checkbox"
                name="marketingOptIn"
                checked={form.marketingOptIn}
                onChange={onChange}
              />
              <span>
                I would like to receive special deals, updates, partner rewards
                and exclusive offers from Globtel and Lumisim. I understand that
                I can unsubscribe at any time.
              </span>
            </label>
          </div>

          {/* Actions + Inline verification bar */}
          <div className="actions actions--with-verify">
            <div className="actions__left">
              <button
                type="submit"
                className="btn btn--primary"
                disabled={
                  status?.type === "loading" || status?.type === "success"
                }
              >
                {status?.type === "loading" ? "Registering..." : "Register"}
              </button>

              {/* {status?.type === "error" && (
                <span className="note err" role="alert" aria-live="assertive">
                  {status.msg}
                </span>
              )}
              {status?.type === "success" && (
                <span className="note ok" role="status" aria-live="polite">
                  {status.msg}
                </span>
              )}
              {status?.type === "info" && (
                <span className="note" role="status" aria-live="polite">
                  {status.msg}
                </span>
              )}
              {status?.type === "loading" && (
                <span className="note" role="status" aria-live="polite">
                  {status.msg}
                </span>
              )} */}
              {status?.msg && (
                <span
                  className={`note ${
                    status.type === "error"
                      ? "err"
                      : status.type === "success"
                        ? "ok"
                        : ""
                  }`}
                  role="status"
                >
                  {status.msg}
                </span>
              )}
            </div>

            {/* {status?.type === "info" && (
              <div
                className="actions__right verify-inline--row"
                role="group"
                aria-label="Email verification"
              >
                <div className="verify-code-wrap">
                  <label htmlFor="code" className="sr-only">
                    Verification code
                  </label>
                  <input
                    id="code"
                    name="code"
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value.toUpperCase())}
                    inputMode="latin"
                    autoComplete="one-time-code"
                    placeholder="ABC123"
                    maxLength={6}
                  />
                  <button
                    type="button"
                    className="verify-btn-inside"
                    disabled={
                      status?.type === "loading" || status?.type === "success"
                    }
                    onClick={handleVerifyAndRegister}
                    aria-label="Verify code and create account"
                  >
                    Verify
                  </button>
                </div>
              </div>
            )} */}
          </div>
        </form>
      </section>
    </main>
  );
}
